import { Slider as Slider$1 } from 'radix-ui';
import classnames from 'classnames';
import React__default, { useState } from 'react';
import styles from './Slider.module.scss.js';

/**
 * A slider component that allows the user to select a value from a range.
 * This component is always uncontrolled. It can be set up with a default value
 * and will call back with its own updates.
 */
function Slider({ min = 0, max, step, defaultValue = min, onChangeValue = () => { }, labelBuilder, classes = [], disabled = false, withLabel = false, size = 'small', }) {
    const [value, setValue] = useState(defaultValue);
    return (React__default.createElement(Slider$1.Root, { className: classnames(styles['slider-root'], ...classes), defaultValue: [defaultValue], max: max, min: min, step: step, disabled: disabled, onValueChange: ([intermediateValue]) => {
            setValue(intermediateValue);
        }, onValueCommit: ([updatedValue]) => {
            console.log(updatedValue);
            setValue(updatedValue);
            onChangeValue(updatedValue);
        } },
        React__default.createElement(Slider$1.Track, { className: classnames(styles['track']) },
            React__default.createElement(Slider$1.Range, { className: classnames(styles['range'], styles['single'], {
                    [styles['track--disabled']]: disabled,
                }) })),
        React__default.createElement(Slider$1.Thumb, { "aria-label": "Volume", className: classnames(styles['thumb'], styles[`thumb--${size}`], {
                [styles['thumb--disabled']]: disabled,
            }) },
            React__default.createElement("svg", { width: "8", height: "8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React__default.createElement("path", { className: styles['thumb__icon'], d: "M4.001 1v6m3-6v6m-6-6v6", strokeWidth: "2", strokeLinecap: "round" })),
            withLabel && (React__default.createElement("p", { className: classnames(styles['thumb__caption'], {
                    [styles['thumb__caption--disabled']]: disabled,
                }, 'caption') }, labelBuilder ? labelBuilder(value) : value)))));
}

export { Slider };
//# sourceMappingURL=Slider.js.map
